import type { ToolCustomization } from '@magicschool/business-logic/tools';

/**
 * EAS-365: a custom chatbot is admitted to the CDS runtime once its migration_status is `ready` or
 * `live`. Canonical predicate, kept in its own client-safe module (type-only import, no server graph)
 * so the customize-drawer store, the customize page, and the chat runtime all share one definition
 * rather than re-inlining the status set.
 */
export const isChatbotMigrationAdmitted = (customization: Pick<ToolCustomization, 'migration_status'>): boolean =>
  customization.migration_status === 'ready' || customization.migration_status === 'live';
